import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DCardFooter({ className, style, children, }) {
    return (_jsx("div", { className: classNames('card-footer', className), style: style, children: children }));
}
//# sourceMappingURL=DCardFooter.js.map